// extracted by mini-css-extract-plugin
export default {"title":"styles_title__zR3OH","label":"styles_label__kV7LV","input":"styles_input__IiRmb"};